export const QueryKey = {
    ModulesByParticipant: "modulesByParticipant"
} as const
